// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ce5195ef","455":"0b54ab43","977":"b6910d87"}[chunkId] + ".chunk.js";
};